import styles from './ReportingUseCasesSection.module.scss';

import React from 'react';
import Link from 'gatsby-link';
import RetinaImage from 'src/components/RetinaImage';
import { Button, Container, Row, Col } from 'reactstrap';
import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';

import ImgLaptopZoneAndWeight from 'src/images/img-laptop-zone-and-weight.png';
import ImgLaptopZoneAndWeight2x from 'src/images/img-laptop-zone-and-weight@2x.png';

export default (props) => (
  <div styleName='reporting-use-cases-section'>
      <Container>
          <div styleName='text-container'>
              <div className='h2'>Use great data</div>
              <div className='h2 text-blue'>Get great results.</div>
              <div styleName='message'>
                  Here are some examples of how high-performance shipping teams
                  use Galleon reports.
              </div>
              <div styleName='features-table'>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Carrier communication</div>
                      <div>
                          Seeing too many deliveries arriving late? Download a
                          time-in-transit summary and fire it off to your rep for
                          an explanation.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Customer service</div>
                      <div>
                          Want to get ahead of customer complaints? Tee up a daily
                          scheduled report to show you all late and almost-late
                          shipments.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Accounting</div>
                      <div>
                          Finance team sick of manually entering invoice totals?
                          Use an invoice summary CSV for a Quickbooks import
                          instead.
                      </div>
                  </div>
              </div>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container'>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgLaptopZoneAndWeight, ImgLaptopZoneAndWeight2x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/ReportingUseCasesSection.js